import { useMemo } from 'react';
import { useAccount, useMsal } from '@azure/msal-react';
import { BaseApi } from '@trukt/utils/BaseApi';
import { MsalInstance } from '../MsalInstance';
import { requestResolver } from './helpers/requestResolver';
import { responseErrorResolver } from './helpers/responseErrorResolver';

export interface MsalInstanceInterceptorProps {
  apis: BaseApi[];
  instance: MsalInstance;
}

export const MsalInstanceInterceptor = ({ instance, apis }: MsalInstanceInterceptorProps) => {
  const { accounts } = useMsal();

  const account = useAccount(accounts[0] || {});

  const attachResolversToApis = () => {
    apis.forEach((apiItem) => {
      apiItem.instance.interceptors.request.use(async (config) =>
        requestResolver({ config, account, instance }),
      );

      apiItem.instance.interceptors.response.use(
        (response) => response,
        async (error) => responseErrorResolver({ error, account, instance }),
      );
    });
  };

  useMemo(() => {
    attachResolversToApis();
  }, [account]);

  return null;
};
